import { PaperVSQuestionInsert, PaperVSQuestionInsertMany, PaperVSQuestionDelete, PaperVSQuestionUpdate, PaperVSQuestionGetById, PaperVSQuestionGetList, PaperVSQuestionGetPageList } from "@/api/papervsquestion/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    PaperVSQuestionInsert(context, payload) {
        return new Promise((resolve, reject) => {
            PaperVSQuestionInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    PaperVSQuestionInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            PaperVSQuestionInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    PaperVSQuestionUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperVSQuestionUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    PaperVSQuestionGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            PaperVSQuestionGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    PaperVSQuestionGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperVSQuestionGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    PaperVSQuestionGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            PaperVSQuestionGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}